import { JbOfferBlockValueTypeEnum } from 'jb-component-library';

export interface OfferBlockDataType {
  header?: string; // Can contain HTML tags. Ex: <br>
  currencyCode?: string;
  valueType: DotOfferBlockValueType; // CMS can send valueType 'freeform' which is not supported by CL
  discountSuffix: string;
  value?: string; // Can contain HTML tags. Ex: <br>
  footer?: string; // Can contain HTML tags. Ex: <br>
  pointsSuffix: string;
  taxes?: string;
  theme?: string;
}

export enum DotOfferBlockFreeformEnum {
  freeform = 'freeform',
}

export type DotOfferBlockValueType =
  | JbOfferBlockValueTypeEnum
  | DotOfferBlockFreeformEnum;
